// Utility functions for ehr-emulator package
export {};
//# sourceMappingURL=utils.js.map